<template lang="pug">
  b-overlay(:show="loading", spinner-variant="primary", variant="transparent" )
    b-card
      b-tabs
        b-tab.mt-3(title="Edición")
          b-overlay(:show="updating", variant="transparent", spinner-variant="primary" )
            b-form
              input.d-none(type="file", accept="image/*", ref="new_image_input", @change="newImagePicked($event)")
              b-row.mb-3.justify-content-between
                b-col
                  .d-flex.align-items-start
                    div(style="flex:0 0 250px;")
                      .image-container(style="width:300px; flex:0 0 auto; position:relative;")
                        b-form-group.mb-2
                          b-avatar.mb-1(button, variant="light", rounded, size="300", :src="productsPackage.image", @click="$refs.upload_image_input.click()", style="object-fit:contain;", v-b-tooltip.right, :title="productsPackage.image ? 'Cambiar imagen' : 'Subir imagen'")
                            camera-icon(style="width:50px; height:50px; pointer-events:none;", v-if="!productsPackage.image")
                        b-form-row.justify-content-center
                          input(type="file", accept="image/*", ref="upload_image_input", style="display:none;", @change="imagePicked($event)")
                b-col(md="auto")
                  trash-icon.icon-md.hover-danger.pointer(@click="confirmDeletePackage")
              b-row.mb-1
                b-col.mb-1(md="6")
                  b-form-group(label="Nombre", label-size="sm" )
                    b-form-input(placeholder="Nombre del paquete", size="sm", v-model="productsPackage.name", :state="getState(productsPackage.name)", @focus="focused = true")
                b-col(md="6")
                  b-form-group(label="SKU", label-size="sm")
                    b-form-input(placeholder="SKU del paquete", size="sm", v-model="productsPackage.sku", min="0")
                b-col(md="6")
                  b-form-group(label="Precio", label-size="sm")
                    b-input-group(prepend="$", size="sm" )
                      b-form-input(placeholder="Precio", :value="parsedPrice", @input="productsPackage.price = parseFloat($event.replace(/,/g,''))", :state="getState(parsedPrice)", @focus="focused = true", @keypress="numbersOnly")
                b-col.d-flex.justify-content-around(md="6")
                  b-form-group(label="A la venta", label-size="sm")
                    b-input-group
                      span {{ productsPackage.enabled ?  'Sí' : 'No' }}
                      b-form-checkbox.ml-2.mb-2(switch, v-model="productsPackage.enabled")
                  b-form-group(label="Selección múltiple", label-size="sm")
                    b-input-group
                      span {{ productsPackage.multiple ?  'Sí' : 'No' }}
                      b-form-checkbox.ml-2.mb-2(switch, v-model="productsPackage.multiple")
              b-form-group.mb-1(label="Descripción", label-size="sm")
                b-form-textarea(placeholder="Descripción del paquete", size="sm", no-resize, rows="2", max-rows="5", v-model="productsPackage.description")
              b-form-group.mb-1(label="Palabras clave", label-size="sm")
                b-form-tags(v-model="keywords", placeholder="Agregar palabras clave", size="sm", tag-variant="primary", add-button-text="Agregar", duplicate-tag-text="Valores duplicados" )
              b-form-group(label="Categorías", label-size="sm")
                b-button.m-1(v-for="category in categories.filter(el => !el.parent_category_id)", :key="category.category_id", pill, size="sm", :variant="packageCategoriesIds.includes(category.category_id) ? 'an' : 'outline-an'", @click="toggleCategory(category)", :disabled="updatingCategories") {{category.name}}
                div
                b-button.m-1(v-for="category in categories.filter(el => !!el.parent_category_id)", :key="category.category_id", pill, size="sm", :variant="packageCategoriesIds.includes(category.category_id) ? 'an' : 'outline-an'", @click="toggleCategory(category)", :disabled="updatingCategories")
                  div {{category.name}}
                  .text-sm {{getCategoryName(category)}}
              b-button(variant="an", block, type="submit", :disabled="blockButton", @click="updatePackage($event)") Guardar cambios
        b-tab.mt-3(title="Armar paquete")
          .text-right.mb-2
            b-button(variant="an", size="sm", @click="addProductItem", :disabled="creating") Agregar elemento
          empty-message(message="No hay elementos agregados aún", v-if="!packageItems.length && !creating")
          PackageItem(v-for="(item, index) in packageItems", :key="index", :package-item="item", @destroy="removeItem")
</template>

<script>
import PackageItem from "@/components/PackageItem";
import { createNamespacedHelpers, mapActions } from 'vuex'
import { toBase64 } from '@/helpers/file-converter'
import { UploadFile } from '@/helpers/upload-file'

const productPackageController = createNamespacedHelpers('products_package')
const categoryController = createNamespacedHelpers('category')

export default {
  data() {
    return {
      loading: false,
      creating: false,
      updatingCategories: false,
      productsPackage: {
        product_package_id: null,
        account_id: null,
        name: null,
        sku: null,
        image: null,
        description: null,
        price: null,
        enabled: false,
        keywords: []
      },
      focused: false,
      packageItems: [],
      updating: false,
      file: null,
      image: null,
      imageFile: null,
      keywords: [],
      packageCategoriesIds: []
    }
  },
  computed: {
    ...productPackageController.mapState({
      productsPackages: state => state.product_packages
    }),
    ...categoryController.mapState({
      categories: state => state.categories
    }),
    parsedPrice() {
      const { price } = this.productsPackage
      const formatter = new Intl.NumberFormat('es-MX')
      let parsed = formatter.format(price)

      if (parsed === 'NaN') parsed = ''

      return parsed
    },
    blockButton() {
      return !this.productsPackage.name
    },
  },
  methods: {
    ...mapActions([
      'products_package/get',
      'products_package/update',
      'products_package/destroy',
      'products_package/addCategory',
      'products_package/removeCategory',
      'products_package/createItem',
      'helpers/upload_file'
    ]),
    getState(value) {
      return ([undefined, '', null].includes(value) && this.focused) ? false : null
    },
    getPackage() {
      const self = this
      this.loading = true

      this['products_package/get']({
        product_package_id: self.$route.params.product_package_id,
        callback: (res) => {
          this.loading = false
          if (res.error) return self.$message.error(res.error)

          const { resource = {} } = res
          const { Package_Items = [], Categories = [] } = resource

          this.productsPackage = resource
          this.packageItems = Package_Items.slice()
          this.packageCategoriesIds = Categories.map(({category_id}) => category_id)
          const { keywords = '' } = this.productsPackage

          if (keywords) this.keywords = keywords.split(',')
        }
      })
    },
    confirmDeletePackage() {
      const self = this

      this.$bvModal
          .msgBoxConfirm(
              `¿Deseas eliminar el paquete de productos ${this.productsPackage.name || ''}? No se puede deshacer.`,
              {
                title: 'Eliminar paquete de productos',
                okTitle: 'Eliminar',
                okVariant: 'danger',
                cancelTitle: 'Cancelar'
              }
          )
          .then((value) => {
            if (value === true) self.deletePackage()
          })
          .catch((err) => {
            console.error(err)
          })
    },
    deletePackage() {
      const self = this
      const { product_package_id: productPackageId } = self.$route.params

      this['products_package/destroy']({
        product_package_id: productPackageId,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Paquete de productos eliminado')
          this.goToPackageProducts()
        }
      })
    },
    async updatePackage(event) {
      event.preventDefault()

      this.updating = true
      const self = this

      if (this.file) {
        try {
          this.imageFile = await UploadFile.call(this, this.file)
          this.productsPackage.image = this.imageFile
        } catch (e) {
          self.$message.error('Error subiendo imagen')

          this.updating = false
          return
        }
      }

      this.productsPackage.keywords = this.keywords.join(',')

      this['products_package/update']({
        account_id: self.$route.params.account_id,
        ...this.productsPackage,
        callback: (res) => {
          self.updating = false

          if (res.error) return self.$message.error(res.error)

          self.$message.success('Paquete de productos actualizado')
        }
      })
    },
    toggleCategory ({category_id}) {
      let index = this.packageCategoriesIds.findIndex(id => id === category_id)
      index >= 0 ? this.destroyCategory(category_id, index) : this.assignCategory(category_id)
    },
    assignCategory(category_id) {
      this.updatingCategories = true

      this['products_package/addCategory']({
        product_package_id: this.$route.params.product_package_id,
        category_id,
        callback: (res) => {
          this.updatingCategories = false
          if (res.error) return this.$message.error(res.error)
          this.packageCategoriesIds.push(category_id)
        },
      })
    },
    destroyCategory(category_id, index) {
      this.updatingCategories = true

      this["products_package/removeCategory"]({
        product_package_id: this.$route.params.product_package_id,
        category_id,
        callback: (res) => {
          this.updatingCategories = false
          if (res.error) return this.$message.error(res.error)
          this.packageCategoriesIds.splice(index, 1);
        },
      });
    },
    addProductItem() {
      const self = this

      this['products_package/createItem']({
        product_package_id: self.$route.params.product_package_id,
        quantity: 1,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
          if(!res.resource.Package_Item_Options) {
            res.resource.Package_Item_Options = []
          }
          self.packageItems.push(res.resource)
        }
      })
    },
    removeItem(item) {
      const index = this.packageItems.findIndex((element) => {
        return element.package_item_id === item.package_item_id
      })
      if (index >= 0) return this.packageItems.splice(index, 1)
    },
    async imagePicked(event) {
      const file = event.target.files[0]
      this.productsPackage.image = URL.createObjectURL(file)
      this.file = file
    },
    async newImagePicked(event) {
      const file = event.target.files[0]

      if (file) {
        this.image = URL.createObjectURL(file)

        try {
          this.showLoadingScreen()

          this.image = await UploadFile.call(this, file)
          this.productsPackage.image = this.image

          this.hideLoadingScreen()
        } catch (e) {
          console.log(e)

          self.$message.error('Error subiendo imagen')

          return this.hideLoadingScreen()
        }
      }
    },
    async uploadFile(file) {
      const self = this

      return new Promise(async (resolve, reject) => {
        const params = { file_name: file.name, mime: file.type }

        try {
          if (file.name.includes('.')) params.file_extension = file.name.split('.').slice(-1)
        } catch (e) {
          console.log(e.message)
        }

        try {
          const fileBase64 = await toBase64(file, true)

          params.file = fileBase64
        } catch (e) {
          console.log(e.message)

          reject(new Error('Error cargando archivo'))
        }

        self['helpers/upload_file']({
          ...params,
          callback: (res) => {
            if (res.error) return reject(new Error(res.error))

            resolve(res.resource.url)
          }
        })
      })
    },
    goToPackageProducts() {
      if(this.productsPackages.length) {
        this.$router.push({name: 'Package', params: { product_package_id: this.productsPackages[0].product_package_id } }).catch(() => {})
        return
      }
      this.$router.push({ name: 'Products Package' }).catch(() => {})
    },
    numbersOnly(e) {
      const charCode = e.keyCode

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      }

      return true
    },
    getCategoryName ({parent_category_id}) {
      const category = this.categories.find(({category_id}) => category_id === parent_category_id)
      return category ? `de ${category.name}` : ''
    }
  },
  mounted () {
    this.getPackage()
  },
  components: { PackageItem }
}
</script>

<style lang="scss">
  .center-in-container {
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
    z-index: 1;
  }

  .height {
    max-height: 305px;
  }

  .add-image-button {
    width: 150px;
    height: 150px;
    border: 2px dashed #4a5dff;
    border-radius: 5px;

    &:hover {
      color: #4a5dff;
    }
  }
</style>
